import { FC, PropsWithChildren, useId } from 'react';

import IndexContext, { TabContextProviderProps, TabContextValues } from './context';

export const TabContextProvider: FC<PropsWithChildren<TabContextProviderProps>> = ({
  children,
  ...rest
}) => {
  const id = useId();
  const getLabelId = (value: string) => `tab-${id}-${value}`;
  const getContentId = (value: string) => `${id}-tabpanel-${value}`;

  const values: TabContextValues = {
    ...rest,
    getLabelId,
    getContentId,
  };

  return <IndexContext.Provider value={values}>{children}</IndexContext.Provider>;
};

export default TabContextProvider;
